<template>
    <div>
        <page-title>{{ $t('menu.impersonate') }}</page-title>

        <form-panel>
            <v-autocomplete
                v-model="userId"
                :items="users"
                item-value="id"
                item-text="email"
                :label="$t('labels.email')"
                :loading="preload"
                :search-input.sync="search"
            >
            </v-autocomplete>

            <v-btn :disabled="!userId" :loading="loading" @click="login">{{
                $t('auth.login_submit')
            }}</v-btn>
        </form-panel>
    </div>
</template>
<style lang="scss" scoped>
.loader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    z-index: 1000000;
}
</style>

<script>
import PageTitle from '@/components/layout/components/pageTitle'
import FormPanel from '@/components/form/FormPanel.vue'
import selectApiClientType from '@/api/SelectApiClientType'
import authType from '@/store/type/authType'
import UsersApiClient from '@/api/RestApi/UsersApiClient'

export default {
    components: {
        FormPanel,
        PageTitle,
    },
    data() {
        return {
            userId: null,
            loading: false,
            preload: true,
            users: [],
            search: '',
        }
    },
    computed: {
        selectApiClientType() {
            return selectApiClientType
        },
        isAdminUser() {
            if (this.$store.getters[authType.getters.IS_RESTAURANT_ADMIN]) {
                return true
            }
            if (this.$store.getters[authType.getters.IS_COMPANY_ADMIN]) {
                return true
            }
            if (this.$store.getters[authType.getters.IS_SUPER_ADMIN]) {
                return true
            }
            return false
        },
    },
    watch: {
        search() {
            this.load()
        },
    },
    async mounted() {},
    methods: {
        async load() {
            this.preload = true

            if (this.i) {
                clearTimeout(this.i)
            }
            this.i = setTimeout(async () => {
                const users = (
                    await UsersApiClient.list({
                        itemsPerPage: 99,
                        _search: this.search,
                    })
                )['hydra:member']
                const filtered = users.filter((x) => {
                    return (
                        x.userRoles.findIndex(
                            (y) => y.role === 'ROLE_ADMIN'
                        ) === -1
                    )
                })
                this.users = filtered
                this.preload = false
            }, 500)
        },
        async login() {
            this.loading = true
            await this.$impersonate.login(this.userId)

            this.$impersonate.loginToFrontend()

            this.loading = false
        },
    },
}
</script>
